// extracted by mini-css-extract-plugin
export var Svg = "SvgMap-module--Svg--2jCdS";
export var Path__state = "SvgMap-module--Path__state--1C9KN";
export var Tooltip__Title = "SvgMap-module--Tooltip__Title--3N7dB";